import { render, staticRenderFns } from "./IdCardUpload.vue?vue&type=template&id=76f153d9&scoped=true&"
import script from "./IdCardUpload.vue?vue&type=script&lang=js&"
export * from "./IdCardUpload.vue?vue&type=script&lang=js&"
import style0 from "./IdCardUpload.vue?vue&type=style&index=0&id=76f153d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f153d9",
  null
  
)

export default component.exports